/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getIntegrationConfigurationOverrides';

export type GetIntegrationConfigurationPathParams = NonNullable<
  operations['getIntegrationConfiguration']['parameters']['path']
>;

export interface Input extends GetIntegrationConfigurationPathParams {
  apiVersion?: string;
}

export async function getIntegrationConfiguration(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/integration-configurations/{integrationConfigurationId}', {
    params: { path },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
